
// app/javascript/controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "arrow"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

open() {
  this.menuTarget.classList.remove('hidden')
  if (this.hasArrowTarget) {
    this.arrowTarget.classList.add('rotate-180')
  }
  document.addEventListener('click', this.closeOnClickOutside)
}

close() {
  this.menuTarget.classList.add('hidden')
  if (this.hasArrowTarget) {
    this.arrowTarget.classList.remove('rotate-180')
  }
  document.removeEventListener('click', this.closeOnClickOutside)
}

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside)
  }
}